import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import HelpdeskService from 'services/HelpdeskService'
import {
  openSuccessNotification,
  openErrorNotification,
} from '../../utils/openNotification'
import i18n from '../../lang'

export const initialState = {
  tickets: null,
  ticket: null,
  loading: false,
  showMessage: false,
  ticketIsLoading: false,
  addTicketIsLoading: false,
  addCommentIsLoading: false,
  updateTicketIsLoading: false,
  deleteTicketIsLoading: false,
}

export const listTickets = createAsyncThunk(
  'billing/listTickets',
  async (data, { rejectWithValue }) => {
    try {
      return await HelpdeskService.listTickets(data)
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'Algo deu errado')
    }
  }
)

export const getTicket = createAsyncThunk(
  'billing/getTicket',
  async (data, { rejectWithValue }) => {
    try {
      return await HelpdeskService.getTicket(data)
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'Algo deu errado')
    }
  }
)

export const postTicket = createAsyncThunk(
  'billing/postTicket',
  async (data, { rejectWithValue }) => {
    try {
      return await HelpdeskService.postTicket(data)
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'Algo deu errado')
    }
  }
)

export const postComment = createAsyncThunk(
  'billing/postComment',
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const response = await HelpdeskService.postComment(data)

      await dispatch(getTicket(data?.id))
      return response
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'Algo deu errado')
    }
  }
)

export const putTicket = createAsyncThunk(
  'billing/putTicket',
  async (data, { rejectWithValue }) => {
    try {
      return await HelpdeskService.updateTicket(data)
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'Algo deu errado')
    }
  }
)

export const deleteTicket = createAsyncThunk(
  'billing/deleteTicket',
  async (data, { rejectWithValue }) => {
    try {
      return await HelpdeskService.deleteTicket(data)
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'Error')
    }
  }
)

export const helpdeskSlice = createSlice({
  name: 'helpdesk',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(listTickets.pending, state => {
        state.loading = true
      })
      .addCase(listTickets.fulfilled, (state, action) => {
        state.loading = false
        state.tickets = action.payload
      })
      .addCase(listTickets.rejected, state => {
        state.loading = false
      })
      .addCase(getTicket.pending, state => {
        state.ticketIsLoading = true
      })
      .addCase(getTicket.fulfilled, (state, action) => {
        state.ticketIsLoading = false
        state.ticket = action.payload
      })
      .addCase(getTicket.rejected, state => {
        state.ticketIsLoading = false
      })
      .addCase(postTicket.pending, state => {
        state.addTicketIsLoading = true
      })
      .addCase(postTicket.fulfilled, (state, action) => {
        state.addTicketIsLoading = false
        state.ticket = action.payload
        openSuccessNotification({
          key: 'postTicket',
          message: i18n.t('message.post.support.success'),
        })
      })
      .addCase(postTicket.rejected, (state, action) => {
        state.addTicketIsLoading = false

        openErrorNotification({
          key: 'postTicket',
          message: action.payload || i18n.t('message.default.error'),
        })
      })
      .addCase(postComment.pending, state => {
        state.commentIsLoading = true
      })
      .addCase(postComment.fulfilled, (state, action) => {
        state.commentIsLoading = false
        state.ticket = action.payload
        openSuccessNotification({
          key: 'postComment',
          message: i18n.t('message.comment.support.success'),
        })
      })
      .addCase(postComment.rejected, (state, action) => {
        state.commentIsLoading = false
        openErrorNotification({
          key: 'postComment',
          message: action.payload || i18n.t('message.default.error'),
        })
      })
      .addCase(putTicket.pending, state => {
        state.updateTicketIsLoading = true
      })
      .addCase(putTicket.fulfilled, (state, action) => {
        state.updateTicketIsLoading = false
        state.ticket = action.payload

        openSuccessNotification({
          key: 'updateTicket',
          message: i18n.t('message.update.support.success'),
        })
      })
      .addCase(putTicket.rejected, (state, action) => {
        state.updateTicketIsLoading = false

        openErrorNotification({
          key: 'updateTicket',
          message: action.payload || i18n.t('message.default.error'),
        })
      })
      .addCase(deleteTicket.pending, state => {
        state.deleteTicketIsLoading = true
      })
      .addCase(deleteTicket.fulfilled, (state, action) => {
        state.deleteTicketIsLoading = false
        state.ticket = action.payload

        openSuccessNotification({
          key: 'deleteTicket',
          message: i18n.t('message.delete.support.success'),
        })
      })
      .addCase(deleteTicket.rejected, (state, action) => {
        state.deleteTicketIsLoading = false
        openErrorNotification({
          key: 'deleteTicket',
          message: action.payload || i18n.t('message.default.error'),
        })
      })
  },
})

export default helpdeskSlice.reducer
